import React from 'react'
import { AuthRoles } from '../../Component/Auth/AuthRoles.js';

const LogRoute = [
    {
        path: '/log',
        component: React.lazy(() => import('./Log.js')),
        auth: AuthRoles.editor,
    }
]

export default LogRoute;